export function TargetMiddleAgeIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="Phosphor Icons / Detective">
      <g id="Vector">
      </g>
      <path id="Vector_2" d="M9.5 26C11.433 26 13 24.433 13 22.5C13 20.567 11.433 19 9.5 19C7.567 19 6 20.567 6 22.5C6 24.433 7.567 26 9.5 26Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_3" d="M22.5 26C24.433 26 26 24.433 26 22.5C26 20.567 24.433 19 22.5 19C20.567 19 19 20.567 19 22.5C19 24.433 20.567 26 22.5 26Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_4" d="M13 22.5H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_5" d="M1 15H31" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_6" d="M5 15L11.1625 6.2C11.2553 6.06663 11.3793 5.95789 11.5236 5.88321C11.6679 5.80852 11.8283 5.77013 11.9908 5.77136C12.1533 5.77259 12.313 5.81341 12.4562 5.89027C12.5994 5.96714 12.7217 6.07774 12.8125 6.2125L15.1625 9.75C15.2534 9.88928 15.3775 10.0037 15.5238 10.0829C15.67 10.1621 15.8337 10.2036 16 10.2036C16.1663 10.2036 16.33 10.1621 16.4762 10.0829C16.6225 10.0037 16.7466 9.88928 16.8375 9.75L19.1875 6.2125C19.2783 6.07774 19.4006 5.96714 19.5438 5.89027C19.687 5.81341 19.8467 5.77259 20.0092 5.77136C20.1717 5.77013 20.3321 5.80852 20.4764 5.88321C20.6207 5.95789 20.7447 6.06663 20.8375 6.2L27 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
